import React from 'react';
import { connect } from 'react-redux';
import ContactPersonPhone from './ContactPersonPhone';
import BillingAddress from '../CustomerDetails/Common/BillingAddress';

class ContactPersonFull extends React.Component {
    render() {
        const p = this.props;
        const lookup = window.osa.lookup.optionalCustomerDetails.secondAccountContact;
        return (
            <div>
                <ContactPersonPhone name={p.name} disabled={p.disabled} />
                <div className="row">
                    <div className="col-sm-12">
                        <BillingAddress name={`${p.name}Address`} lookup={lookup.addressOption}
                            selectedBillingAddress={p.selectedAddress} inline disabled={p.disabled} />
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state, props) => {
    return {
        selectedAddress: state.form[`${props.name}Address`]
    };
};
export default connect(mapStateToProps)(ContactPersonFull);
